import { MoveTypes } from "../../../api/Inventory/Entities/InventoryMovementEntities";

type Id = number | string | null | undefined;

interface CartRelease {
    id?: Id;
    lotNumber?: string | null;
}

interface CartAssignment {
    assignmentType?: string | null;
    assignId?: Id;
    kitNumber?: Id;
}

interface CartItem {
    id?: Id;
    externalId?: string | null;
    origin?: string | null;
}

interface ExistingCartLine {
    item: CartItem;
    release?: CartRelease | null;
    assignment: CartAssignment;
}

interface IncomingCartLine {
    inventoryItemId?: Id;
    externalId?: string | null;
    origin?: string | null;
    release?: CartRelease | null;
    assignment: CartAssignment;
}

interface MergeQuantityArgs {
    existingQuantity: number | string;
    incomingQuantity: number | string;
    availableQuantity?: number | null;
    accumulates: boolean;
    maxQuantity?: number | null;
}

// Un movimiento ausente de esta lista reemplaza (el ajuste de stock fija un valor absoluto).
const ACCUMULATING_MOVE_TYPES = [
    MoveTypes.AddStock,
    MoveTypes.PharmacyDispense,
    MoveTypes.PharmacyDispenseRequest,
    MoveTypes.ProtocolDispense,
    MoveTypes.ProtocolDispenseRequest,
    MoveTypes.LaboratoryKitDispense,
    MoveTypes.LaboratoryKitDispenseRequest,
];

export function accumulatesQuantity(moveType: string | null | undefined): boolean {
    return ACCUMULATING_MOVE_TYPES.some(type => MoveTypes.IsEquivalent(moveType, type));
}

export function normalizeLot(value: string | number | null | undefined): string {
    return (value ?? '').toString().trim().toLowerCase();
}

export function matchesCartLine(
    existing: ExistingCartLine,
    { inventoryItemId, externalId, origin, release, assignment }: IncomingCartLine
): boolean {
    const sameItem = Number(inventoryItemId) > 0
        ? existing.item.id == inventoryItemId
        : existing.item.externalId === externalId && existing.item.origin === origin;

    const sameRelease =
        (release == null && existing.release == null)
        || (Number(existing.release?.id) > 0 && Number(release?.id) > 0 && existing.release?.id == release?.id)
        || (normalizeLot(existing.release?.lotNumber) === normalizeLot(release?.lotNumber));

    const sameAssignment =
        existing.assignment.assignmentType == assignment.assignmentType
        && existing.assignment.assignId == assignment.assignId
        && existing.assignment.kitNumber == assignment.kitNumber;

    return sameItem && sameRelease && sameAssignment;
}

export function resolveMergedQuantity({ existingQuantity, incomingQuantity, availableQuantity, accumulates, maxQuantity }: MergeQuantityArgs): number {
    const incoming = Number(incomingQuantity) * 1;
    const next = accumulates ? Number(existingQuantity) * 1 + incoming : incoming;
    const capped = (maxQuantity != null && next > maxQuantity) ? maxQuantity : next;
    return (availableQuantity != null && capped > availableQuantity) ? availableQuantity : capped;
}
